import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Typography,
  Box,
  CardContent,
  Toolbar,
  IconButton,
  Badge,
  Divider,
  Menu,
  MenuItem,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Tooltip,
  ListItemButton,
  ListItemText,
  List,
  ListSubheader,
  Card,
  CardHeader,
  ListItem,
  CardActions,
  ListItemAvatar,
  Avatar,
  Autocomplete,
} from "@mui/material";

import { connect } from "react-redux";
import NoRecordMessage from "../../../common/components/NoRecordMessage";

import { saveTrainerCategory } from "../../../../../store/cpd/actions";

import ConfirmationDialog from "../../../common/components/ConfirmationDialog";
import ReactPaginate from "react-paginate";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useRequiredAuth } from "../../../common/guard/requiredAuth";
import axios from "axios";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const TrainerCategoriesCard = (props) => {
  const { loading, user, trainerCategories, saveTrainerCategory } = props;

  const { hasPermissions } = useRequiredAuth();

  const [name, setName] = useState("");
  const [showAdd, setShowAdd] = useState(false);

  //PAGINATION
  const [paginatedItems, setPaginatedItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 5;

  const paginate = (items) => {
    const endOffset = itemOffset + itemsPerPage;
    setPaginatedItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  };

  useEffect(() => {
    paginate(trainerCategories);
  }, [itemOffset, itemsPerPage, trainerCategories]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % trainerCategories.length || 0;

    setItemOffset(newOffset);
  };

  const getNo = (data, key, idToSearch) =>
    data.findIndex((item) => item[key] === idToSearch);

  const [formData, setFormData] = useState({
    id: null,
    name: "",
    isActive: true,
  });

  const onClose = () => {
    setFormData({
      id: null,
      name: "",
      isActive: true,
    });
    setShowAdd(false);
  };

  return (
    <Card className="border" variant="outlined">
      <div
        // className="mb-3"
        style={{
          height: "40vh",
          overflow: "auto",
        }}
      >
        <List
          dense
          component="div"
          subheader={
            <ListSubheader
              className="border-bottom  bg-light text-uppercase text-primary  d-flex justify-content-between align-items-center"
              component="div"
            >
              Trainer categories
              {/* {hasPermissions(["ADMIN"]) && ( */}
              <IconButton color="primary" onClick={() => setShowAdd(true)}>
                <span className="material-icons">add</span>
              </IconButton>
              {/* )} */}
            </ListSubheader>
          }
        >
          {paginatedItems?.map((item, index) => (
            <TrainerCategoryCardItem
              index={getNo(trainerCategories, "id", item.id)}
              key={item.id}
              loading={loading}
              user={user}
              item={item}
              setFormData={setFormData}
              setShowAdd={setShowAdd}
              saveTrainerCategory={saveTrainerCategory}
              onClose
            />
          ))}
        </List>

        {trainerCategories.length > itemsPerPage && (
          <ReactPaginate
            breakLabel="..."
            nextLabel={
              <>
                <i className="fas fa-angle-double-right"></i>
              </>
            }
            previousLabel={
              <>
                <i className="fas fa-angle-double-left"></i>
              </>
            }
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            pageCount={pageCount}
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
            previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
            nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
            activeLinkClassName="active"
          />
        )}
      </div>

      {showAdd && (
        <AddOrEditTrainerCategory
          loading={loading}
          showAdd={showAdd}
          formData={formData}
          setFormData={setFormData}
          saveTrainerCategory={saveTrainerCategory}
          onClose={onClose}
        />
      )}
    </Card>
  );
};

const mapStateToProps = ({ user, loading, trainerCategories }) => {
  return {
    user,
    loading,
    trainerCategories,
  };
};

export default connect(mapStateToProps, { saveTrainerCategory })(
  TrainerCategoriesCard
);

const TrainerCategoryCardItem = (props) => {
  const {
    loading,
    user,
    item,
    index,
    setFormData,
    setShowAdd,
    saveTrainerCategory,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [showConfirmDisable, setShowConfirmDisable] = useState(false);

  return (
    <>
      <ListItem
        style={{
          backgroundColor: !item.isActive ? "#ff00000f" : "#fff",
        }}
        divider
        key={item.id}
        secondaryAction={
          <span>
            {!item.isActive && (
              <span
                style={{ fontSize: "12px" }}
                className={`material-icons text-danger mr-1`}
              >
                lock
              </span>
            )}

            <IconButton size="small" onClick={handleOpenMenu}>
              <Badge color="info">
                <span className="material-icons">more_vert</span>
              </Badge>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleCloseMenu}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 2,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 15,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <span>
                <MenuItem
                  disabled={loading}
                  onClick={() => {
                    handleCloseMenu();

                    setFormData({
                      id: item.id,
                      name: item.name,
                      isActive: item.isActive,
                    });
                    setShowAdd(true);
                  }}
                  className={`text-primary`}
                >
                  <span className="material-icons mr-2"> edit</span>
                  Edit
                </MenuItem>
              </span>

              <span>
                <MenuItem
                  disabled={loading}
                  onClick={() => {
                    handleCloseMenu();
                    setShowConfirmDisable(true);
                  }}
                  className={`text-${!item.isActive ? "success" : "danger"
                    } font-weight-light`}
                >
                  {item.isActive && (
                    <span className="material-icons mr-2">close</span>
                  )}
                  {!item.isActive && (
                    <span className="material-icons mr-2">check</span>
                  )}
                  {item.isActive ? "Disable" : "Enable"}
                </MenuItem>
              </span>
            </Menu>
          </span>
        }
      >
        <ListItemText
          primary={
            <strong className="text-primary">
              {index + 1}: {item.name}
            </strong>
          }
        // secondary={
        //   <small className="badge badge-pill text-left font-weight-bold">
        //     {item.sector?.district?.name}{" "}
        //     <i
        //       className="fas fa-chevron-right"
        //       style={{ fontSize: "10px" }}
        //     ></i>{" "}
        //     {item.sector?.name}
        //   </small>
        // }
        />
      </ListItem>

      {showConfirmDisable && (
        <ConfirmationDialog
          confirmationDialog={showConfirmDisable}
          message={
            <>
              Are you sure to{" "}
              <strong
                className={`text-${item.isActive ? "danger" : "success"}`}
              >
                {item.isActive ? "disable" : "enable"}
              </strong>{" "}
              this organization type?
            </>
          }
          setConfirmationDialog={setShowConfirmDisable}
          noPreFormat={true}
          onYes={() => {
            saveTrainerCategory(
              {
                id: item.id,
                name: item.name,
                isActive: !item.isActive,
              },
              () => setShowConfirmDisable(false)
            );
          }}
        />
      )}
    </>
  );
};

const AddOrEditTrainerCategory = (props) => {
  const {
    loading,
    showAdd,
    formData,
    setFormData,
    saveTrainerCategory,
    onClose,
  } = props;

  const onSave = () => {
    saveTrainerCategory(
      {
        id: formData.id,
        name: formData.name,
        isActive: formData.isActive,
      },
      () => onClose()
    );
  };

  return (
    <Dialog onClose={onClose} open={showAdd} fullWidth maxWidth="xs">
      <DialogTitle className="text-primary">
        <Typography variant="p" noWrap component="div">
          <span className="text-primary">
            {formData.id ? "Edit " : "Add new "} Trainer Category
          </span>
        </Typography>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            minHeight: "5vh",
          }}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            name="name"
            label={`Name`}
            placeholder={`Name`}
            variant="outlined"
            className="mt-3"
            value={formData.name || ""}
            onChange={(e) => {
              setFormData({
                ...formData,
                name: e.target.value || "",
              });
            }}
          />
        </div>
      </DialogContent>
      <DialogActions className="d-flex justify-content-center py-4">
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          type="button"
          className="px-5"
          disabled={loading || !formData.name}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
